// extracted by css-extract-rspack-plugin
export default {"cls1":"NewUserDiscountButton-cls1_fuZ","cls2":"NewUserDiscountButton-cls2_5FR NewUserDiscountButton-cls1_fuZ"};